import React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";

// Import Pages
import Home from "./Pages/Home";
import AboutUs from "./Pages/AboutUs";
import ManagementTeam from "./Pages/ManagementTeam";
import OnlineEntrance from "./Pages/OnlineEntrance";
import FAQ from "./Pages/FAQ";
import Cocurricular from "./Pages/Cocurricular";
import Extracurricular from "./Pages/Extracurricular";
import Gallery from "./Pages/Gallery";
import Admissions from "./Pages/Admissions";
import Alumni from "./Pages/Alumni";
import Careers from "./Pages/Careers";
import Creche from "./Pages/Creche";
import Elementary from "./Pages/Elementary";
import Secondary from "./Pages/Secondary";
import Contact from "./Pages/Contact";
import Chairman from "./Pages/Chairman";
import Special from "./Pages/Special";
import PrivacyPolicy from "./Pages/Policy";

function App() {
    return (

        <HashRouter>
            <Routes>
                <Route index path="/" element={<Home />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/creche" element={<Creche />} />
                <Route path="/elementary" element={<Elementary />} />
                <Route path="/secondary" element={<Secondary />} />
                <Route path="/special" element={<Special />} />
                <Route path="/management" element={<ManagementTeam />} />
                <Route path="/chairman" element={<Chairman />} />
                <Route path="/entrance" element={<OnlineEntrance />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/cocurricular" element={<Cocurricular />} />
                <Route path="/extracurricular" element={<Extracurricular />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/admissions" element={<Admissions />} />
                <Route path="/alumni" element={<Alumni />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            </Routes>
        </HashRouter>

    );
}

export default App;
